var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.animationShapeRight ? 'animationnew-shap' : 'animation-shap'},[_c('div',{staticClass:"shap-bg"})])
}
var staticRenderFns = []

export { render, staticRenderFns }